import React, { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom';

const Portfolio = () => {
  
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    const navigate = useNavigate();
    const goToSection = (section) => {
        navigate(`${section}`);
    };

  const portfolioItems = [
    { id:1,category: 'app', image: 'product_1.jpeg', title: 'MyBerin', description: 'Lorem ipsum, dolor sit amet consectetur' },
    { id:2,category: 'product', image: 'product_2.jpeg', title: 'Mom NVP', description: 'Lorem ipsum, dolor sit amet consectetur' },
    { id:3,category: 'branding', image: 'product_3.jpeg', title: 'MyBerin', description: 'Lorem ipsum, dolor sit amet consectetur' },
  ];

  return (
    <section id="portfolio" className="portfolio section">
      <div className="container section-title" data-aos="fade-up">
        <span>Portfolio</span>
        <h2>Portfolio</h2>
        <p>Necessitatibus eius consequatur ex aliquid fuga eum quidem sint consectetur velit</p>
      </div>

      <div className="container">
        <div className="row gy-4 isotope-container" data-aos="fade-up" data-aos-delay="200">
            {portfolioItems.map((item, index) => (
              <div key={index} className={`col-lg-4 col-md-6 portfolio-item isotope-item filter-${item.category}`}>
                <img src={`/assets/img/${item.image}`} className="img-fluid" alt="" />
                <div className="portfolio-info">
                  <h4>{item.title}</h4>
                  <p>{item.description}</p>
                  <a href={`/assets/img/${item.image}`} title={item.title} data-gallery={`portfolio-gallery-${item.category}`} className="glightbox preview-link">
                    <i className="bi bi-zoom-in"></i>
                  </a>
                  <a href={`/productdetails`} onClick={(e) => {
                                        e.preventDefault();
                                        goToSection(`/productdetails/${item.id}`);
                                    }} title="More Details" className="details-link">
                    <i className="bi bi-link-45deg"></i>
                  </a>
                </div>
              </div>
            ))}
          </div>
      </div>
    </section>
  );
};

export default Portfolio;
